export default __webpack_public_path__ + "static/media/end-pdf.597b3c0b.png";